import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DualVersionIcdComponent } from './DualVersionICD/dual-version-icd/dual-version-icd.component';
import { DualVersion9IcdComponent } from './DualVersionICD/dual-version9-icd/dual-version9-icd.component';
import { Icd10Component } from './icd10/icd10.component';
import { Icd9Component } from './icd9/icd9.component';
import { InstructionIcd10Component } from './instruction-icd10/instruction-icd10.component';
import { InstructionIcd9Component } from './instruction-icd9/instruction-icd9.component';
import { SearchGlobalDetailComponent } from './search-global-detail/search-global-detail.component';
import { SearchGlobalComponent } from './search-global/search-global.component';
import { IcfComponent } from './icf/icf.component';
import { DualVersionIcfComponent } from './DualVersionICD/dual-version-icf/dual-version-icf.component';
import { InstructionIcfComponent } from './instruction-icf/instruction-icf.component';
import { DashboardMccdComponent } from './dashboard/dashboard-mccd/dashboard-mccd.component';
import { DashboardUcodComponent } from './dashboard/dashboard-ucod/dashboard-ucod.component';
import  { ToolsUcodComponent}from './tools/tools-ucod/tools-ucod.component'
import { NotificationComponent } from './notification/notification.component';
import { Icd10v3Component } from './icd10v3/icd10v3.component';

// Import new LOINC components
import { LoincTableComponent } from './loinc/loinc-table/loinc-table.component';
// import { LoincMapToComponent } from './loinc/loinc-map-to/loinc-map-to.component';
// import { LoincPartComponent } from './loinc/loinc-part/loinc-part.component';
// import { LoincPartLinkComponent } from './loinc/loinc-part-link/loinc-part-link.component';
import { LoincPanelsFormsComponent } from './loinc/loinc-panels-forms/loinc-panels-forms.component';
// import { LoincAnswerListsComponent } from './loinc/loinc-answer-lists/loinc-answer-lists.component';
// import { LoincAnswersComponent } from './loinc/loinc-answers/loinc-answers.component';
// import { LoincAnswerListLinksComponent } from './loinc/loinc-answer-list-links/loinc-answer-list-links.component';




const searchRoutes: Routes = [
    {
        path: 'search-global',
        component: SearchGlobalComponent,
        data: { title: 'ICD Smart Search' },
    },
    {
        path: 'query-global',
        component: SearchGlobalDetailComponent,
        data: { title: 'ICD Smart Search' },
    },
]

@NgModule({
    imports: [RouterModule.forChild(searchRoutes)],
    exports: [RouterModule],
})
export class SearchRoutingModule {}

const toolRoutes: Routes = [
    {
        path: 'ucod',
        component: ToolsUcodComponent,
        data: { title: 'Tools UCOD VIET NAM' },
    }
]

@NgModule({
    imports: [RouterModule.forChild(toolRoutes)],
    exports: [RouterModule],
})
export class ToolsRoutingModule {}

const notificationRoutes: Routes = [
    {
        path: 'notification-list',
        component: NotificationComponent,
        data: { title: 'Notification List' },
    }
]


@NgModule({
    imports: [RouterModule.forChild(notificationRoutes)],
    exports: [RouterModule],
})
export class NotificationRoutingModule {}

const dashboardRoutes: Routes = [
    {
        path: 'ucod',
        component: DashboardUcodComponent,
        data: { title: 'Dashboard UCOD' },
    },
    {
        path: 'mccd',
        component: DashboardMccdComponent,
        data: { title: 'Dashboard MCCD' },
    }
]

@NgModule({
    imports: [RouterModule.forChild(dashboardRoutes)],
    exports: [RouterModule],
})
export class DashboardRoutingModule {}

const icd9Routes: Routes = [
    {
        path: 'icd9',
        component: Icd9Component,
        data: { title: 'ICD-9' },
    },
    {
        path: 'icd9-dual',
        component: DualVersion9IcdComponent,
        data: { title: 'ICD-9 Dual' },
    },
    {
        path: 'instruction-icd9',
        component: InstructionIcd9Component,
        data: { title: 'ICD-9 Instruction' },
    }
]

@NgModule({
    imports: [RouterModule.forChild(icd9Routes)],
    exports: [RouterModule],
})
export class Icd9RoutingModule {}

const icd10Routes: Routes = [
    {
        path: 'icd10',
        component: Icd10Component,
        data: { title: 'ICD-10' },
    },
    {
        path: 'icd10-dual',
        component: DualVersionIcdComponent,
        data: { title: 'ICD-10 Dual' },
    },
    {
        path: 'instruction-icd10',
        component: InstructionIcd10Component,
        data: { title: 'ICD-10 Instruction' },
    },
    {
        path: 'icd10v3',
        component: Icd10v3Component,
        data: { title: 'ICD10 v3' },
    },
]

@NgModule({
    imports: [RouterModule.forChild(icd10Routes)],
    exports: [RouterModule],
})
export class ICD10RoutingModule {}

const icfRoutes: Routes = [
    {
        path: 'icf',
        component: IcfComponent,
        data: { title: 'ICF' },
    },
    {
        path: 'icf-dual',
        component: DualVersionIcfComponent,
        data: { title: 'ICF Dual' },
    },
    {
        path: 'instruction-icf',
        component: InstructionIcfComponent,
        data: { title: 'ICF - Instruction' },
    }
]

@NgModule({
    imports: [RouterModule.forChild(icfRoutes)],
    exports: [RouterModule],
})
export class ICFRoutingModule {}


const loincRoutes: Routes = [
    {
        path: 'loinc-table',
        component: LoincTableComponent,
        data: { title: 'LOINC Table' },
    },
    {
        path: 'loinc-table/:id',
        component: LoincTableComponent,
        data: { title: 'LOINC Table' },
    },
    // {
    //     path: 'loinc-table/map-to',
    //     component: LoincMapToComponent,
    //     data: { title: 'LOINC Map To' },
    // },
    // {
    //     path: 'loinc-table/map-to/:id',
    //     component: LoincMapToComponent,
    //     data: { title: 'LOINC Map To' },
    // },
    // {
    //     path: 'loinc-part/part',
    //     component: LoincPartComponent,
    //     data: { title: 'LOINC Part' },
    // },
    // {
    //     path: 'loinc-part/part/:id',
    //     component: LoincPartComponent,
    //     data: { title: 'LOINC Part' },
    // },
    // {
    //     path: 'loinc-part/part-link',
    //     component: LoincPartLinkComponent,
    //     data: { title: 'LOINC Part Link' },
    // },
    // {
    //     path: 'loinc-part/part-link/:id',
    //     component: LoincPartLinkComponent,
    //     data: { title: 'LOINC Part Link' },
    // },
    {
        path: 'panels-and-forms',
        component: LoincPanelsFormsComponent,
        data: { title: 'LOINC Panels & Forms' },
    },
    {
        path: 'panels-and-forms/:id',
        component: LoincPanelsFormsComponent,
        data: { title: 'LOINC Panels & Forms' },
    },
    // {
    //     path: 'loinc-answers/answer-lists',
    //     component: LoincAnswerListsComponent,
    //     data: { title: 'LOINC Answer Lists' },
    // },
    // {
    //     path: 'loinc-answers/answer-lists/:id',
    //     component: LoincAnswerListsComponent,
    //     data: { title: 'LOINC Answer Lists' },
    // },
    // {
    //     path: 'loinc-answers/answers',
    //     component: LoincAnswersComponent,
    //     data: { title: 'LOINC Answers' },
    // },
    // {
    //     path: 'loinc-answers/answers/:id',
    //     component: LoincAnswersComponent,
    //     data: { title: 'LOINC Answers' },
    // },
    // {
    //     path: 'loinc-answers/answer-list-links',
    //     component: LoincAnswerListLinksComponent,
    //     data: { title: 'LOINC Answer List Links' },
    // },
    // {
    //     path: 'loinc-answers/answer-list-links/:id',
    //     component: LoincAnswerListLinksComponent,
    //     data: { title: 'LOINC Answer List Links' },
    // }
];

@NgModule({
    imports: [RouterModule.forChild(loincRoutes)],
    exports: [RouterModule],
})
export class LoincRoutingModule {} 